export enum TrackingFeedbackRating {
    VeryUnhappy = 'very unhappy',
    Unhappy = 'unhappy',
    Neutral = 'neutral',
    Happy = 'happy',
    VeryHappy = 'very happy',
}
